import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedHTMLMessage } from 'react-intl'
import uuid from 'uuid'
import { compose, pure } from 'recompose'
import { AjType } from 'containers/forms/aj-events'
import { Title, Section } from 'components/layout'
import { AjLoader } from 'components/loaders'
import { apiAjEvents } from 'helpers/decorators/api'
import { AJ_EVENT_TYPES } from 'constants/enums'
import AjPreparationTraining from '../../../pages/Awards/AjPreparationTraining'

const enhance = compose(
  pure,
  apiAjEvents({
    list: true,
    updateList: true,
    resetFilter: true,
    filter: 'participantEvents',
    listReadParams: 'APPEND_CUSTOMIZATIONS,PARTICIPANT_EVENTS,PARTICIPANT_PERSON'
  })
)

class AdventureJourney extends Component {
  static propTypes = {
    isParentLoading: PropTypes.bool,
    ajEvents: PropTypes.object.isRequired,
    awardId: PropTypes.number.isRequired,
    approveAjEventParticipant: PropTypes.func.isRequired,
    returnAjEventParticipant: PropTypes.func.isRequired,
    approveAjEvent: PropTypes.func.isRequired,
    rejectAjEvent: PropTypes.func.isRequired,
    changeAjParticipantEventState: PropTypes.func.isRequired,
    changeAjParticipantEventGoal: PropTypes.func.isRequired,
    isOffline: PropTypes.bool,
    codeLists: PropTypes.object,
    isSimplifiedBronze: PropTypes.bool
  }

  key = uuid.v1()

  render() {
    const { ajEvents, params, awardId, isParentLoading, isOffline, codeLists, isSimplifiedBronze } = this.props

    const ajEventsList = ajEvents.list.map(item => {
      return {
        ...item,
        participantEvent: get(item, 'ajParticipantEvents', []).filter(event => {
          return (
            get(event, 'award.participant.id') === Number(get(params, 'id'))
          )
        })[0]
      }
    })

    const ajEventsListPractice = ajEventsList.filter(
      item =>
        get(item, 'participantEvent.ajEventCategoryType') ===
        AJ_EVENT_TYPES.practice.id
    )
    const ajEventsListQualifying = ajEventsList.filter(
      item =>
        get(item, 'participantEvent.ajEventCategoryType') ===
        AJ_EVENT_TYPES.qualification.id
    )

    if (isOffline) {
      return (
        <FormattedHTMLMessage
          id="activity.cannot_edit_activity_offline"
          defaultMessage="You cannot edit activity if Award is in offline mode"
        />
      )
    }

    const loading = ajEvents.loading && !isParentLoading

    return (
      <Section loading={loading} contentLoader={<AjLoader />}>

        <div className="row">
          <div className="col-xs-12">
            {awardId && <AjPreparationTraining awardId={awardId} decoAwardId={awardId}/>}
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <Title
              h2
              intlKey="aj.practice_journey"
              className="base-margin--top"
            >
              Practice Journey
            </Title>
            <AjType
              key={this.key}
              data={ajEventsListPractice}
              changeAjParticipantEventState={
                this.props.changeAjParticipantEventState
              }
              approveAjEvent={this.props.approveAjEvent}
              rejectAjEvent={this.props.rejectAjEvent}
              approveAjEventParticipant={this.props.approveAjEventParticipant}
              returnAjEventParticipant={this.props.returnAjEventParticipant}
              changeAjParticipantEventGoal={
                this.props.changeAjParticipantEventGoal
              }
              codeLists={codeLists}
              isSimplifiedBronze={isSimplifiedBronze}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <Title
              h2
              intlKey="aj.qualifying_journey"
              className="base-margin--top"
            >
              Qualifying Journey
            </Title>
            <AjType
              key={this.key}
              data={ajEventsListQualifying}
              changeAjParticipantEventState={
                this.props.changeAjParticipantEventState
              }
              approveAjEvent={this.props.approveAjEvent}
              rejectAjEvent={this.props.rejectAjEvent}
              approveAjEventParticipant={this.props.approveAjEventParticipant}
              returnAjEventParticipant={this.props.returnAjEventParticipant}
              changeAjParticipantEventGoal={
                this.props.changeAjParticipantEventGoal
              }
              codeLists={codeLists}
            />
          </div>
        </div>
      </Section>
    )
  }
}

export default enhance(AdventureJourney)
